function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useEffect, useState } from 'react';
import classnames from 'classnames';
import { Text } from "../Text/Text/Text";
import { ValidatedInput } from "../Input/ValidatedInput/ValidatedInput";
import { Button } from "../Button/Button/Button";
import { CheckboxInput } from "../Input/CheckboxInput/CheckboxInput";
import { Theme } from "../Background/Theme/Theme";
import styles from "./CancellationForm.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var CancellationForm = function CancellationForm(_ref) {
  var _cancellationType$opt, _cancellationTime$opt, _form$inputs;
  var headline = _ref.headline,
    form = _ref.form,
    confirmation = _ref.confirmation,
    _ref$status = _ref.status,
    status = _ref$status === void 0 ? {
      errorMessage: '',
      success: false
    } : _ref$status;
  var _ref2 = form || {},
    cancellationTime = _ref2.cancellationTime,
    cancellationType = _ref2.cancellationType;
  var _ref3 = (form === null || form === void 0 ? void 0 : form.inputs) || {},
    ordinaryCheckbox = _ref3.ordinaryCheckbox,
    extraordinaryCheckbox = _ref3.extraordinaryCheckbox,
    earliestPossibleCheckbox = _ref3.earliestPossibleCheckbox,
    chooseDateCheckbox = _ref3.chooseDateCheckbox;
  var _ref4 = confirmation || {},
    receipt = _ref4.receipt;
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    memberId = _useState2[0],
    setMemberId = _useState2[1];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    firstName = _useState4[0],
    setFirstName = _useState4[1];
  var _useState5 = useState(''),
    _useState6 = _slicedToArray(_useState5, 2),
    lastName = _useState6[0],
    setLastName = _useState6[1];
  var _useState7 = useState(''),
    _useState8 = _slicedToArray(_useState7, 2),
    email = _useState8[0],
    setEmail = _useState8[1];
  var _useState9 = useState(''),
    _useState10 = _slicedToArray(_useState9, 2),
    telephoneNumber = _useState10[0],
    setTelephoneNumber = _useState10[1];
  var _useState11 = useState(false),
    _useState12 = _slicedToArray(_useState11, 2),
    disableButton = _useState12[0],
    setDisableButton = _useState12[1];
  var _useState13 = useState(''),
    _useState14 = _slicedToArray(_useState13, 2),
    cancelReason = _useState14[0],
    setCancelReason = _useState14[1];
  var _useState15 = useState(cancellationType === null || cancellationType === void 0 ? void 0 : (_cancellationType$opt = cancellationType.options[0]) === null || _cancellationType$opt === void 0 ? void 0 : _cancellationType$opt.label),
    _useState16 = _slicedToArray(_useState15, 2),
    cancelType = _useState16[0],
    setCancelType = _useState16[1];
  var _useState17 = useState(cancellationTime === null || cancellationTime === void 0 ? void 0 : (_cancellationTime$opt = cancellationTime.options[0]) === null || _cancellationTime$opt === void 0 ? void 0 : _cancellationTime$opt.label),
    _useState18 = _slicedToArray(_useState17, 2),
    cancelTime = _useState18[0],
    setCancelTime = _useState18[1];
  var _useState19 = useState(true),
    _useState20 = _slicedToArray(_useState19, 2),
    chk1 = _useState20[0],
    setChk1 = _useState20[1];
  var _useState21 = useState(false),
    _useState22 = _slicedToArray(_useState21, 2),
    chk2 = _useState22[0],
    setChk2 = _useState22[1];
  var _useState23 = useState(true),
    _useState24 = _slicedToArray(_useState23, 2),
    chk3 = _useState24[0],
    setChk3 = _useState24[1];
  var _useState25 = useState(false),
    _useState26 = _slicedToArray(_useState25, 2),
    chk4 = _useState26[0],
    setChk4 = _useState26[1];
  var toggleCheckmark = function toggleCheckmark(id, onChange) {
    if (onChange) {
      onChange();
    }
    switch (id) {
      case 'chk1':
        setChk1(true);
        setChk2(false);
        setCancelType(cancellationType === null || cancellationType === void 0 ? void 0 : cancellationType.options[0].label);
        break;
      case 'chk2':
        setChk2(true);
        setChk1(false);
        setCancelType(cancelReason);
        break;
      case 'chk3':
        setChk3(true);
        setChk4(false);
        setCancelTime(cancellationTime === null || cancellationTime === void 0 ? void 0 : cancellationTime.options[0].label);
        break;
      case 'chk4':
        setChk4(true);
        setChk3(false);
        setCancelTime((form === null || form === void 0 ? void 0 : form.inputs.date.text) || '');
        break;
    }
  };
  useEffect(function () {
    if (cancelType === (cancellationType === null || cancellationType === void 0 ? void 0 : cancellationType.options[0].label)) {
      setCancelReason('');
    }
    var isValid = function isValid(text, regex) {
      return text && regex.test(text);
    };
    if (!isValid(firstName, form === null || form === void 0 ? void 0 : form.inputs.firstName.regex) || !isValid(lastName, form === null || form === void 0 ? void 0 : form.inputs.lastName.regex) || !isValid(email, form === null || form === void 0 ? void 0 : form.inputs.email.regex) || cancelType === (cancellationType === null || cancellationType === void 0 ? void 0 : cancellationType.options[1].label) && !cancelReason || cancelTime !== (cancellationTime === null || cancellationTime === void 0 ? void 0 : cancellationTime.options[0].label) && !isValid(cancelTime, form === null || form === void 0 ? void 0 : form.inputs.date.regex) || status !== null && status !== void 0 && status.errorMessage) {
      return setDisableButton(true);
    } else {
      return setDisableButton(false);
    }
  }, [cancelTime, cancellationTime === null || cancellationTime === void 0 ? void 0 : cancellationTime.options, cancelReason, cancelType, email, firstName, lastName, cancellationType === null || cancellationType === void 0 ? void 0 : cancellationType.options, status === null || status === void 0 ? void 0 : status.errorMessage, form === null || form === void 0 ? void 0 : form.inputs.firstName, form === null || form === void 0 ? void 0 : form.inputs.lastName, form === null || form === void 0 ? void 0 : form.inputs.email, form === null || form === void 0 ? void 0 : form.inputs.date]);
  var renderText = function renderText(typog) {
    var text = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    var className = arguments.length > 2 ? arguments[2] : undefined;
    var textElement = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'div';
    var richText = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
    return /*#__PURE__*/_jsx(Text, {
      className: className,
      typog: typog,
      textElement: textElement,
      richText: richText,
      children: text
    });
  };
  var renderValidatedInput = function renderValidatedInput(setStateFunc, otherProps) {
    var className = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : styles.formInput;
    return /*#__PURE__*/_jsx(ValidatedInput, _objectSpread(_objectSpread({
      className: className,
      statusMessageClassName: styles.statusMessage,
      hasButton: false
    }, otherProps), {}, {
      onChangeText: function onChangeText(e) {
        setStateFunc(e);
        if (otherProps.onChangeText) {
          otherProps.onChangeText(e);
        }
      }
    }));
  };
  var formatLabel = function formatLabel() {
    var label = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    if (label.includes(':')) {
      return label;
    }
    if (label.includes('*')) {
      label = label.replace('*', ':');
    } else {
      label = label + ':';
    }
    return label;
  };
  return /*#__PURE__*/_jsxs("div", {
    className: styles.background,
    children: [/*#__PURE__*/_jsx(Theme, {
      theme: 'darkBackground',
      children: /*#__PURE__*/_jsx(Text, {
        className: styles.headline,
        typog: 'headline4',
        children: headline
      })
    }), /*#__PURE__*/_jsxs(Theme, {
      theme: 'lightBackground',
      children: [!(status !== null && status !== void 0 && status.success) && /*#__PURE__*/_jsx("div", {
        className: styles.container,
        children: /*#__PURE__*/_jsxs("div", {
          className: styles.form,
          children: [renderText('subhead3', form === null || form === void 0 ? void 0 : form.login.headline, styles.loginHeadline), renderText('bodycopyLarge', form === null || form === void 0 ? void 0 : form.login.body, styles.marginMedium), /*#__PURE__*/_jsx(Button, _objectSpread(_objectSpread({
            className: styles.marginMedium,
            size: "medium"
          }, form === null || form === void 0 ? void 0 : form.login.cta), {}, {
            children: form === null || form === void 0 ? void 0 : form.login.cta.text
          })), /*#__PURE__*/_jsx("div", {
            className: classnames(styles.separator, styles.marginLarge),
            children: renderText('subhead3', form === null || form === void 0 ? void 0 : form.separatorText)
          }), renderText('bodycopyLarge', form === null || form === void 0 ? void 0 : form.inputFieldHeading, styles.marginLarge), renderText('subhead3', form === null || form === void 0 ? void 0 : form.inputFieldSubheading, styles.marginMedium), /*#__PURE__*/_jsxs("div", {
            className: classnames(styles.inputsWrapper, styles.marginMedium),
            children: [renderValidatedInput(setMemberId, form === null || form === void 0 ? void 0 : form.inputs.memberId, styles.formInputFullWidth), renderValidatedInput(setFirstName, form === null || form === void 0 ? void 0 : form.inputs.firstName), renderValidatedInput(setLastName, form === null || form === void 0 ? void 0 : form.inputs.lastName), renderValidatedInput(setEmail, form === null || form === void 0 ? void 0 : form.inputs.email), renderValidatedInput(setTelephoneNumber, form === null || form === void 0 ? void 0 : form.inputs.telephone)]
          }), renderText('subhead3', cancellationType === null || cancellationType === void 0 ? void 0 : cancellationType.headline, styles.cancellationTypeHeadline), /*#__PURE__*/_jsxs("div", {
            className: styles.marginSmall,
            children: [/*#__PURE__*/_jsx(CheckboxInput, {
              name: "chk1",
              className: styles.formCheckbox,
              label: cancellationType === null || cancellationType === void 0 ? void 0 : cancellationType.options[0].label,
              checked: chk1,
              onChange: function onChange() {
                return toggleCheckmark('chk1', ordinaryCheckbox.onChange);
              }
            }), (cancellationType === null || cancellationType === void 0 ? void 0 : cancellationType.options[0].text) && renderText('bodycopySmall', cancellationType === null || cancellationType === void 0 ? void 0 : cancellationType.options[0].text, styles.checkboxText), /*#__PURE__*/_jsx(CheckboxInput, {
              name: "chk2",
              className: styles.formCheckbox,
              label: cancellationType === null || cancellationType === void 0 ? void 0 : cancellationType.options[1].label,
              checked: chk2,
              onChange: function onChange() {
                return toggleCheckmark('chk2', extraordinaryCheckbox.onChange);
              }
            }), (cancellationType === null || cancellationType === void 0 ? void 0 : cancellationType.options[1].text) && renderText('bodycopySmall', cancellationType === null || cancellationType === void 0 ? void 0 : cancellationType.options[1].text, styles.checkboxText)]
          }), renderText('subhead4', cancellationType === null || cancellationType === void 0 ? void 0 : cancellationType.reason.headline, styles.marginMedium), /*#__PURE__*/_jsx("div", {
            className: classnames(styles.reasonTextArea, {
              [styles.disabled]: cancelType === (cancellationType === null || cancellationType === void 0 ? void 0 : cancellationType.options[0].label)
            }),
            children: /*#__PURE__*/_jsx("textarea", {
              id: "textArea",
              rows: 4,
              maxLength: 200,
              placeholder: cancellationType === null || cancellationType === void 0 ? void 0 : cancellationType.reason.placeholder,
              onChange: function onChange(e) {
                var _cancellationType$rea;
                if (cancellationType !== null && cancellationType !== void 0 && (_cancellationType$rea = cancellationType.reason) !== null && _cancellationType$rea !== void 0 && _cancellationType$rea.onChange) {
                  var _cancellationType$rea2;
                  cancellationType === null || cancellationType === void 0 ? void 0 : (_cancellationType$rea2 = cancellationType.reason) === null || _cancellationType$rea2 === void 0 ? void 0 : _cancellationType$rea2.onChange(e.target.value);
                }
                setCancelReason(e.target.value);
              },
              value: cancelReason,
              children: cancelReason
            })
          }), renderText('bodycopySmall', cancellationType === null || cancellationType === void 0 ? void 0 : cancellationType.reason.criteria, styles.marginLarge), renderText('subhead3', cancellationTime === null || cancellationTime === void 0 ? void 0 : cancellationTime.headline, styles.cancellationTimeHeadline), renderText('bodycopyLarge', cancellationTime === null || cancellationTime === void 0 ? void 0 : cancellationTime.body, styles.marginSmall), /*#__PURE__*/_jsxs("div", {
            className: styles.marginSmall,
            children: [/*#__PURE__*/_jsxs("div", {
              className: styles.marginSmall,
              children: [/*#__PURE__*/_jsx(CheckboxInput, {
                name: "chk3",
                className: styles.formCheckbox,
                label: cancellationTime === null || cancellationTime === void 0 ? void 0 : cancellationTime.options[0].label,
                checked: chk3,
                onChange: function onChange() {
                  return toggleCheckmark('chk3', earliestPossibleCheckbox.onChange);
                }
              }), (cancellationTime === null || cancellationTime === void 0 ? void 0 : cancellationTime.options[0].text) && renderText('bodycopySmall', cancellationTime === null || cancellationTime === void 0 ? void 0 : cancellationTime.options[0].text, styles.checkboxText), /*#__PURE__*/_jsx(CheckboxInput, {
                name: "chk4",
                className: classnames(styles.formCheckbox),
                label: cancellationTime === null || cancellationTime === void 0 ? void 0 : cancellationTime.options[1].label,
                checked: chk4,
                onChange: function onChange() {
                  return toggleCheckmark('chk4', chooseDateCheckbox.onChange);
                }
              }), (cancellationTime === null || cancellationTime === void 0 ? void 0 : cancellationTime.options[1].text) && renderText('bodycopySmall', cancellationTime === null || cancellationTime === void 0 ? void 0 : cancellationTime.options[1].text, styles.checkboxText)]
            }), renderValidatedInput(setCancelTime, form === null || form === void 0 ? void 0 : (_form$inputs = form.inputs) === null || _form$inputs === void 0 ? void 0 : _form$inputs.date, classnames(styles.formInputCancellationTime, {
              [styles.disabled]: cancelTime === (cancellationTime === null || cancellationTime === void 0 ? void 0 : cancellationTime.options[0].label)
            }))]
          }), /*#__PURE__*/_jsx(Button, _objectSpread(_objectSpread({
            className: styles.submitCta,
            disabled: disableButton,
            size: "large"
          }, form === null || form === void 0 ? void 0 : form.submitCta), {}, {
            children: form === null || form === void 0 ? void 0 : form.submitCta.text
          })), (status === null || status === void 0 ? void 0 : status.errorMessage) && renderText('bodycopy', status === null || status === void 0 ? void 0 : status.errorMessage, styles.error)]
        })
      }), (status === null || status === void 0 ? void 0 : status.success) && /*#__PURE__*/_jsxs("div", {
        className: styles.container,
        children: [/*#__PURE__*/_jsxs("div", {
          className: styles.topSquare,
          children: [renderText('headline4', confirmation.headline, styles.submittedHeadline), renderText('bodycopyLarge', confirmation.body, styles.marginSmall, 'div', true)]
        }), /*#__PURE__*/_jsxs("div", {
          className: classnames(styles.bottomSquare, styles.marginMedium),
          children: [renderText('subhead2', confirmation.receipt.headline, styles.receiptHeadline), /*#__PURE__*/_jsxs("div", {
            className: classnames(styles.receiptTextContainer, styles.marginMedium),
            children: [memberId && /*#__PURE__*/_jsxs("div", {
              className: styles.receiptTextWrapper,
              children: [renderText('subhead3', formatLabel(form === null || form === void 0 ? void 0 : form.inputs.memberId.placeholder), styles.receiptText), renderText('bodycopy', memberId, styles.receiptTextInput)]
            }), /*#__PURE__*/_jsxs("div", {
              className: styles.receiptTextWrapper,
              children: [renderText('subhead3', formatLabel(form === null || form === void 0 ? void 0 : form.inputs.firstName.placeholder), styles.receiptText), renderText('bodycopy', firstName, styles.receiptTextInput)]
            }), /*#__PURE__*/_jsxs("div", {
              className: styles.receiptTextWrapper,
              children: [renderText('subhead3', formatLabel(form === null || form === void 0 ? void 0 : form.inputs.lastName.placeholder), styles.receiptText), renderText('bodycopy', lastName, styles.receiptTextInput)]
            }), /*#__PURE__*/_jsxs("div", {
              className: styles.receiptTextWrapper,
              children: [renderText('subhead3', formatLabel(form === null || form === void 0 ? void 0 : form.inputs.email.placeholder), styles.receiptText), renderText('bodycopy', email, styles.receiptTextInput, 'span')]
            }), telephoneNumber && /*#__PURE__*/_jsxs("div", {
              className: styles.receiptTextWrapper,
              children: [renderText('subhead3', formatLabel(form === null || form === void 0 ? void 0 : form.inputs.telephone.placeholder), styles.receiptText), renderText('bodycopy', telephoneNumber, styles.receiptTextInput)]
            }), /*#__PURE__*/_jsxs("div", {
              className: styles.receiptTextWrapper,
              children: [renderText('subhead3', formatLabel(cancellationType === null || cancellationType === void 0 ? void 0 : cancellationType.headline), styles.receiptText), renderText('bodycopy', chk1 ? cancellationType === null || cancellationType === void 0 ? void 0 : cancellationType.options[0].label : cancelReason, styles.receiptTextInput)]
            }), /*#__PURE__*/_jsxs("div", {
              className: styles.receiptTextWrapper,
              children: [renderText('subhead3', formatLabel(receipt.membershipEnd), styles.receiptText), renderText('bodycopy', cancelTime, styles.receiptTextInput)]
            }), /*#__PURE__*/_jsxs("div", {
              className: styles.receiptTextWrapper,
              children: [renderText('subhead3', formatLabel(receipt.requestReceived), styles.receiptText), renderText('bodycopy', receipt.requestTimestamp, styles.receiptTextInput)]
            }), /*#__PURE__*/_jsx(Button, _objectSpread(_objectSpread({
              className: styles.marginLarge
            }, confirmation.receipt.printCta), {}, {
              children: confirmation.receipt.printCta.text
            }))]
          })]
        })]
      })]
    })]
  });
};